export default {
  ratePlanType: {
    STANDARD: 'Tiêu chuẩn',
    BAR: 'Giá tốt nhất hiện có',
    CORPORATE: 'Doanh nghiệp',
    MEMBER: 'Thành viên',
    PACKAGE: 'Gói',
    PROMOTIONAL: 'Khuyến mãi',
    OTA: 'OTA',
    WHOLESALE: 'Bán buôn',
    NEGOTIATED: 'Giá thỏa thuận',
    MIXED: 'Giá kết hợp',
  },
} as const;
